import { type ChangeEvent, useState } from "react";

import BulkActionsConfirmActionStepInlineConfirmation from "components/BulkActions/ConfirmActionStep/InlineConfirmation";
import BulkActionsConfirmActionStepActionNote from "components/BulkActions/ConfirmActionStep/ActionNote";

import { StacksBulkActionsConfirmActionStepProps } from "./types";

type StacksBulkActionsConfirmActionStepReviewProps = StacksBulkActionsConfirmActionStepProps;

const StacksBulkActionsConfirmActionStepReview = ({
  bulkActionsVariant,
  onConfirm,
  onCancel,
  action,
}: StacksBulkActionsConfirmActionStepReviewProps) => {
  const [note, setNote] = useState<string>("");

  const handleConfirm = () => {
    onConfirm(
      {
        reviewNote: note,
      },
      {
        view: bulkActionsVariant,
        metadata: {
          hasNote: !!note,
        },
      }
    );
  };

  const onNoteChange = (event: ChangeEvent<HTMLTextAreaElement>) => {
    setNote(event.target.value);
  };

  return (
    <>
      <BulkActionsConfirmActionStepActionNote
        variant={bulkActionsVariant}
        label={"Add a note for review action"}
        onChange={onNoteChange}
      />
      <BulkActionsConfirmActionStepInlineConfirmation
        variant={bulkActionsVariant}
        actionLabel={action.title.toLowerCase()}
        onConfirm={handleConfirm}
        onCancel={onCancel}
      />
    </>
  );
};

export default StacksBulkActionsConfirmActionStepReview;
